export const MESSAGE_WEEKLY = {
  EDIT_SUCCESS: 'Edit success',
  DELETE_SUCCESS: 'Delete success',
  CHANGE_NAME_SUCCESS: 'Change name success',
  CREATE_FOLDER_SUCCESS: 'Create folder success',
  MOVE_FOLDER_SUCCESS: 'Move folder success',
  UPLOAD_SUCCESS: 'Upload success',
  TOKEN_EXPIRED: 'Access token has expired or is not yet valid.',
  TOKEN_401: 'Request failed with status code 401',
  FOLDER_EMPTY: 'Folder does not exist file'
}
